import { FieldInputProps, FieldMetaProps } from 'formik';
import React from 'react';

import { ExclamationCircle } from '@td-client-frontend/icons';

interface FormFieldError<V = any> {
  field: FieldInputProps<V> & { id?: string };
  meta: FieldMetaProps<V>;
  hideError?: boolean;
}

export function FormFieldError({ field, meta, hideError }: FormFieldError) {
  const isError: boolean = hideError ? false : !!(meta.touched && meta.error);
  // id, role, and aria-live added for aria feedback for forms, do not remove/move
  // https://www.w3.org/WAI/WCAG21/quickref/#error-identification
  return (
    <div className='text-xs italic font-bold text-danger' data-testid='form-field-error'>
      {isError ? (
        <div
          id={`${field?.id || field.name}_error`}
          aria-live='assertive'
          role='alert'
          className='flex items-center w-full text-current'
        >
          <ExclamationCircle className='w-5 h-5 m-1 fill-current' />
          {meta.error}
        </div>
      ) : null}
    </div>
  );
}
